import { useQuery } from '@tanstack/react-query'
import {
  fetchCompletedWeeks,
  fetchSeasonStandings,
  fetchWeekResults,
  fetchWeekWinners,
} from './api'

export function useSeasonStandings(poolId: string | undefined) {
  return useQuery({
    queryKey: ['standings', 'season', poolId],
    queryFn: () => fetchSeasonStandings(poolId!),
    enabled: Boolean(poolId),
  })
}

export function useCompletedWeeks(poolId: string | undefined) {
  return useQuery({
    queryKey: ['standings', 'weeks', poolId],
    queryFn: () => fetchCompletedWeeks(poolId!),
    enabled: Boolean(poolId),
  })
}

export function useWeekResults(poolId: string | undefined, weekId: string | undefined) {
  return useQuery({
    queryKey: ['standings', 'week', poolId, weekId],
    queryFn: () => fetchWeekResults(poolId!, weekId!),
    enabled: Boolean(poolId && weekId),
  })
}

export function useWeekWinners(poolId: string | undefined, weekId: string | undefined) {
  return useQuery({
    queryKey: ['standings', 'winners', poolId, weekId],
    queryFn: () => fetchWeekWinners(poolId!, weekId!),
    enabled: Boolean(poolId && weekId),
  })
}
